"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deposits = exports.Deposit = void 0;
class Deposit {
    constructor(deposit) {
        this.id = 0;
        this.date = new Date();
        this.coin = '';
        this.amount = 0;
        this.status = '';
        if (!deposit)
            return;
        this.id = deposit.id;
        this.date = deposit.date;
        this.coin = deposit.coin;
        this.amount = deposit.amount;
        this.status = deposit.status;
        this.record = deposit.record;
        this.receiptPic = deposit.receiptPic;
    }
}
exports.Deposit = Deposit;
class Deposits {
    constructor(deposits) {
        this.list = [];
        this.isLoaded = false;
        if (!deposits)
            return;
        this.isLoaded = deposits.isLoaded;
        this.list = deposits.list;
    }
}
exports.Deposits = Deposits;
//# sourceMappingURL=deposit.js.map